import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { FormField } from "./form-field";
/** Renders a dynamic form's fields via its layout (or a single column) plus a result banner. */
export function DynamicForm(_ref) {
  var _tags$display_text;
  var schema = _ref.schema,
    layout = _ref.layout,
    response = _ref.response,
    tags = _ref.tags,
    onFieldChange = _ref.onFieldChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var spanClass = function spanClass(span) {
    return span === 2 ? "sm:col-span-2" : span === 3 ? "sm:col-span-3" : "col-span-1";
  };
  var colsClass = function colsClass(cols) {
    return cols === 2 ? "sm:grid-cols-2" : cols === 3 ? "sm:grid-cols-3" : "grid-cols-1";
  };
  var alertClass = function alertClass(alert) {
    return alert === "pass" ? "bg-sds-success-tertiary text-sds-success-secondary" : alert === "high" ? "bg-sds-urgent-tertiary text-sds-urgent-secondary" : "bg-sds-attention-tertiary text-sds-attention-secondary";
  };
  var renderField = function renderField(field) {
    return /*#__PURE__*/React.createElement("div", {
      key: field.id,
      className: spanClass(field.columnSpan)
    }, /*#__PURE__*/React.createElement(FormField, {
      field: field,
      value: response[field.id],
      disabled: Boolean(field.disabled),
      onChange: function onChange(value) {
        return onFieldChange(field.id, value);
      }
    }));
  };
  var banner = tags !== null && tags !== void 0 && tags.value ? (_tags$display_text = tags.display_text) === null || _tags$display_text === void 0 ? void 0 : _tags$display_text[tags.value] : undefined;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, layout && layout.length ? layout.map(function (group, index) {
    var fields = group.components.map(function (id) {
      return schema.find(function (item) {
        return item.id === id;
      });
    }).filter(function (item) {
      return Boolean(item);
    });
    return /*#__PURE__*/React.createElement("div", {
      key: "group-".concat(index),
      className: "grid gap-4 ".concat(colsClass(group.columns))
    }, fields.map(renderField));
  }) : /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 gap-4"
  }, schema.map(renderField)), banner ? /*#__PURE__*/React.createElement("div", {
    className: "rounded-sds-200 px-4 py-3 text-style-body-small-strong ".concat(alertClass(banner.alert))
  }, t(banner.text)) : null);
}